import type { ConditionalFormattingPreviewRenderer } from '../store/schema/ConditionalFormattingStore';
import { getConditionalFormattingStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export default function getConditionalFormattingPreviewRenderer(
    mailboxInfo: MailboxInfo
): ConditionalFormattingPreviewRenderer | undefined {
    return getConditionalFormattingStore(mailboxInfo, 'Mail').previewRenderer;
}
